var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sub-detail"},[(_vm.title)?_c('div',{staticClass:"sub-detail-title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{staticClass:"sub-detail-content flex-wrap"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }